// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.slider-prompt_modal-content_QkxFF {
    width: 360px;
}

.slider-prompt_body_AL6x3 {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
}

.slider-prompt_label_gaoZC {
    font-weight: 500;
    margin: 0 0 0.75rem;
}

.slider-prompt_min-input_wMvJ_, .slider-prompt_max-input_ORQ_1 {
    margin-bottom: 1.5rem;
    width: 100%;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 5px;
    padding: 0 1rem;
    height: 3rem;
    color: var(--ui-text-primary-transparent);
    font-size: .875rem;
    background-color: var(--input-background);
}

.slider-prompt_button-row_viDI3 {
    font-weight: bolder;
    text-align: right;
}

.slider-prompt_button-row_viDI3 button {
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    background: white;
    color: black;
    border: 1px solid var(--ui-black-transparent);
    font-weight: 600;
    font-size: 0.85rem;
}

.slider-prompt_button-row_viDI3 button.slider-prompt_ok-button_YKlJZ {
    background: var(--looks-secondary);
    border: var(--looks-secondary);
    color: white;
}

[dir="ltr"] .slider-prompt_button-row_viDI3 button + button {
    margin-left: 0.5rem;
}

[dir="rtl"] .slider-prompt_button-row_viDI3 button + button {
    margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/slider-prompt/slider-prompt.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal-content {\n    width: 360px;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n}\n\n.label {\n    font-weight: 500;\n    margin: 0 0 0.75rem;\n}\n\n.min-input, .max-input {\n    margin-bottom: 1.5rem;\n    width: 100%;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 5px;\n    padding: 0 1rem;\n    height: 3rem;\n    color: var(--ui-text-primary-transparent);\n    font-size: .875rem;\n    background-color: var(--input-background);\n}\n\n.button-row {\n    font-weight: bolder;\n    text-align: right;\n}\n\n.button-row button {\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    background: white;\n    color: black;\n    border: 1px solid var(--ui-black-transparent);\n    font-weight: 600;\n    font-size: 0.85rem;\n}\n\n.button-row button.ok-button {\n    background: var(--looks-secondary);\n    border: var(--looks-secondary);\n    color: white;\n}\n\n[dir=\"ltr\"] .button-row button + button {\n    margin-left: 0.5rem;\n}\n\n[dir=\"rtl\"] .button-row button + button {\n    margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `slider-prompt_modal-content_QkxFF`;
export { _1 as "modal-content" };
export var modalContent = `slider-prompt_modal-content_QkxFF`;
export var body = `slider-prompt_body_AL6x3`;
export var label = `slider-prompt_label_gaoZC`;
var _2 = `slider-prompt_min-input_wMvJ_`;
export { _2 as "min-input" };
export var minInput = `slider-prompt_min-input_wMvJ_`;
var _3 = `slider-prompt_max-input_ORQ_1`;
export { _3 as "max-input" };
export var maxInput = `slider-prompt_max-input_ORQ_1`;
var _4 = `slider-prompt_button-row_viDI3`;
export { _4 as "button-row" };
export var buttonRow = `slider-prompt_button-row_viDI3`;
var _5 = `slider-prompt_ok-button_YKlJZ`;
export { _5 as "ok-button" };
export var okButton = `slider-prompt_ok-button_YKlJZ`;
export default ___CSS_LOADER_EXPORT___;
